import { connect } from 'react-redux';

import { Graphs, IGraphsProps } from './Graphs';
import { IApplicationState, TThunkDispatch, TIndexTab, TRegionGraph } from '../../../types/redux';
import { getLabels, getDatasets, getLegend, getGraphType, getGraphValuesType } from '../selectors';
import { toggleGraphRegion, getGraphs, toggleGraphValuesType } from '../../../actions/graphs';

type TStoreProps = Pick<IGraphsProps, 'isVisible' | 'legend'>;
type TDispatchProps = Pick<IGraphsProps, 'toggleGraphRegion' | 'getGraphs'>;

export function mapStateToPropsGraphs(state: IApplicationState): TStoreProps {
  const labels = getLabels(state.graphs);
  const datasets = getDatasets(state.graphs, state.graphs.regionGraph);
  const legend = getLegend(datasets);

  const isVisible = labels.length > 0 && datasets.length > 0;

  return {
    isVisible,
    legend,
  };
}

export function mapDispatchToPropsGraphs(dispatch: TThunkDispatch): TDispatchProps {
  return {
    toggleGraphRegion: (region: TRegionGraph) => dispatch(toggleGraphRegion(region)),
    getGraphs: (indexTab: TIndexTab) => {
      dispatch(toggleGraphValuesType(getGraphValuesType(indexTab)));
      dispatch(getGraphs(getGraphType(indexTab)));
    },
  };
}

export const GraphsContainer = connect(mapStateToPropsGraphs, mapDispatchToPropsGraphs)(Graphs);
